import { render, staticRenderFns } from "./Motivation.vue?vue&type=template&id=872c838c&"
import script from "./Motivation.vue?vue&type=script&lang=js&"
export * from "./Motivation.vue?vue&type=script&lang=js&"
import style0 from "./Motivation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports